import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { LOAN_CONFIG } from '../config/constants';

export const useLoanCalculator = (amount, duration) => {
  const { t } = useTranslation();

  const monthlyPayment = useMemo(() => {
    const monthlyRate = LOAN_CONFIG.INTEREST_RATE / 12;
    const payment = (amount * monthlyRate * Math.pow(1 + monthlyRate, duration)) / 
                    (Math.pow(1 + monthlyRate, duration) - 1);
    return payment.toFixed(2);
  }, [amount, duration]);

  const totalAmount = useMemo(() => {
    return (parseFloat(monthlyPayment) * duration).toFixed(2);
  }, [monthlyPayment, duration]);

  const formatEuro = (value) => {
    return new Intl.NumberFormat('fi-FI', { 
      style: 'currency', 
      currency: 'EUR',
      maximumFractionDigits: 0 
    }).format(value);
  };

  const formatDuration = useMemo(() => {
    if (duration < 12) {
      return `${duration} ${t('months')}`;
    }
    const years = Math.floor(duration / 12);
    const months = duration % 12;
    if (months === 0) {
      return `${years} ${t('years')}`;
    }
    return `${years} ${t('years')} ${months} ${t('months')}`;
  }, [duration, t]);

  return {
    monthlyPayment,
    totalAmount,
    formatEuro,
    formatDuration
  };
};